<template>
  <div
    v-if="dataDashboard"
    :class="'border border-secondary-subtle rounded rounded-4 p-3 mb-3 position-relative' + (dataDashboard.class? (' '+dataDashboard.class): '')"
  >
    <div
        v-if="loading && loading.status === true"
        class="position-absolute top-0 start-0 z-2 bg-white opacity-75 w-100 h-100 rounded rounded-4 d-flex justify-content-center align-items-center"
      >
        <div class="d-flex align-items-center">
          <strong class="me-3">Loading...</strong>
          <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
        </div>
      </div>
    <template
      v-if="dataDashboard.reload"
    >
      <div
          class="position-absolute top-0 end-0 z-1"
      >
        <a
          @click.prevent="reloadAction(dataDashboard.reload)"
          href="#reload"
          class="link-secondary opacity-50 fs-4 me-2"
          title="Nacist znovu data"
        >
          <i class="bi bi-arrow-repeat"></i>
        </a>


      </div>
    </template>

    <h3
      v-if="dataDashboard.title"
      class="text-primary fw-lighter"
    >
      {{dataDashboard.title}}
    </h3>

    <template
      v-if="dataDashboard.items"
    >
      <template
        v-for="(item, index) in dataDashboard.items"
      >
        <template
          v-if="item.type == 'text'"
        >
          <p
              v-html="item.value"
              class="text-secondary"
          />
        </template>

        <template
            v-else-if="item.type == 'infoboxes'"
        >
          <div
            class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5  g-3  masonry-container"
          >
            <template
              v-for="(box) in item.boxes"
            >
              <div
                class="col masonry-item"
              >
                <div
                    :class="'border border-secondary-subtle rounded rounded-3 px-2  bg-white' + (box.class?' '+box.class:'')"
                >
                  <span class="fs-1 fw-bold d-inline-block mt-2 mx-2">
                    <i v-if="box.icon" :class="box.icon + ' me-1'"></i>
                    {{box.big}}
                  </span>
                  <span
                      v-if="box.small"
                      v-html="box.small"
                      class="ms-1 fw-bolder"
                  />
                  <p
                      v-if="box.title"
                      v-html="box.title"
                      class="mx-2 rounded-top-3"
                  />

                  <div
                      v-if="box.switch"
                      class="d-flex justify-content-end mx-2 mb-2"
                  >
                    <div
                       class="form-check form-switch"
                    >
                      <label class="--form-check-label">
                        <input
                            :ref="'box_switch_' + index"
                            @change="switchAction($event, 'box_switch_' + index, {switch: box.switch}, null)"
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            :checked="box.switch.value"
                        />
                        <span
                            :ref="'box_switch_' + index + '_label'"
                        >
                          {{ box.switch.title }}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div
                    v-if="box.buttons"
                    class="d-flex justify-content-end me-2 mb-2"
                  >
                    <template
                      v-for="(button, index) in box.buttons"
                    >
                      <div
                          v-if="button.type == 'action'"
                          @click.prevent="buttonAction(button)"
                          :class="button.class + ' ms-2'"
                      >
                        <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                        <span v-if="button.title">{{button.title}}</span>
                      </div>
                      <router-link
                          v-else-if="button.type == 'router'"
                          :to="button.path"
                          :class="button.class + ' ms-2'"
                      >
                        <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                        <span v-if="button.title">{{button.title}}</span>
                      </router-link>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>

        </template>

        <template
            v-else-if="item.type == 'buttons'"
        >
          <div
            class="d-flex justify-content-start"
          >
            <template
                v-for="(button, index) in item.buttons"
            >
              <div
                class="d-flex me-4"
              >
                <div
                  v-if="button.type == 'action'"
                  @click.prevent="buttonAction(button)"
                  :class="button.class + ' btn-lg'"
                >
                  <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                  <span v-if="button.title">{{button.title}}</span>
                </div>
                <router-link
                    v-else-if="button.type == 'router'"
                    :to="button.path"
                    :class="button.class + ' btn-lg'"
                >
                  <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                  <span v-if="button.title">{{button.title}}</span>
                </router-link>
                <p
                  v-if="button.description"
                  class="text-secondary fw-light ms-2 mt-2"
                >
                  {{button.description}}
                </p>
              </div>
            </template>
          </div>
        </template>

        <template
            v-else-if="item.type == 'success' && item.value"
        >
          <div
            class="d-flex justify-content-center"
          >
            <div
              class="p-3 d-flex justify-content-center align-items-center"
            >
              <i
                  :class="item.value.icon + ' text-success fs-1'"
              ></i>
              <div class="text-success ms-2 fs-5">
                {{item.value.text}}
              </div>
            </div>
          </div>
        </template>

        <template
            v-else-if="item.type == 'error' && item.value"
        >
          <div
              class="d-flex justify-content-center"
          >
            <div
                class="p-3 d-flex justify-content-center align-items-center"
            >
              <i
                  :class="item.value.icon + ' text-danger fs-1'"
              ></i>
              <div class="text-danger ms-2 fs-5">
                {{item.value.text}}
              </div>
            </div>
          </div>
        </template>

        <template
          v-else-if="item.type == 'list'"
        >

          <template
              v-if="item.list && Object.keys(item.list).length > 0"
          >
            <table
              class="table table-responsive table-striped table-hover"
            >
              <thead
                v-if="item.header && Object.keys(item.header).length > 0"
              >
                <tr>
                  <template
                      v-for="(headerItem, index) in item.header"
                  >
                    <th
                        v-if="headerItem.title"
                        class="text-center"
                    >
                      {{headerItem.title}}
                    </th>
                  </template>

                </tr>
              </thead>

              <draggable
                  :list="item.list"
                  itemKey="ident"
                  handle=".move-row"
                  ghost-class="move-ghost"
                  class="bg-info"
                  tag="tbody"
                  @end="listDragnDropAction(item.list, item.actions)"
              >
                <template #item="{ index, element }">

                  <tr
                      :ref="'row_' + index "
                      :class="element.class?element.class:'no-class'"
                  >
                    <template
                        v-for="(cellItem, cellIndex) in element.content"
                    >
                      <template
                          v-if="cellItem.type == 'checkbox'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header) "
                        >
                          <input
                              :ref="'checkbox_' + cellIndex"
                              type="checkbox"
                              v-model="formData"
                              :value="cellItem.value"
                              class="form-check-input ms-2"
                          >
                        </td>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'move'"
                      >
                        <td
                            :class="'' + getCellClass(cellIndex, item.header)"
                        >
                          <i class="bi bi-arrows-move fs-5 text-secondary move-row"/>
                        </td>
                      </template>
                      <template
                          v-else-if="cellItem.type == 'image'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header) "
                        >
                          <image-component
                              v-if="cellItem.image_id"
                              :image-id="cellItem.image_id"
                              :is_preview_only="true"
                          />
                        </td>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'multiline'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header) "
                        >
                          <template
                              v-if="cellItem.value"
                              v-for="(line, index) in cellItem.value"
                          >
                            <p
                                v-html="line"
                                class="text-muted fs-6"
                            />
                          </template>
                        </td>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'progress_bar'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header) "
                        >
                          <div class="progress">
                            <div
                                class="progress-bar"
                                :style="'width:' + cellItem.procents + '%'"
                            >
                            <span
                                v-if="cellItem.procents > 25"
                            >
                              {{cellItem.title}}
                            </span>
                            </div>
                            <span
                                v-if="cellItem.procents < 25"
                                class="ps-1 text-primary"
                            >
                            {{cellItem.title}}
                          </span>
                          </div>
                        </td>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'ico'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header) "
                        >
                          <i
                              v-if="cellItem.value"
                              :class="cellItem.value"
                          />
                        </td>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'bool'"
                      >
                        <template
                            v-if="cellItem.value === true"
                        >
                          <td
                              :class="'text-success '+ getCellClass(cellIndex, item.header) "
                          >
                            <i class="bi bi-check"></i>
                            <span>Ano</span>
                          </td>
                        </template>
                        <template
                            v-else-if="cellItem.value === false"
                        >
                          <td
                              :class="'text-danger '+ getCellClass(cellIndex, item.header)"
                          >
                            <i class="bi bi-x"></i>
                            <span>Ne</span>
                          </td>
                        </template>
                        <template
                            v-else
                        >
                          <td></td>

                        </template>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'switch'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header)"
                        >
                          <div class="form-check form-switch">
                            <label class="--form-check-label">
                              <input
                                  :ref="'switch_' + index + '_' + cellIndex"
                                  @change="switchAction($event, 'switch_' + index + '_' + cellIndex, cellItem, listItem)"
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  :checked="cellItem.value"
                              />
                              <span
                                  :ref="'switch_' + index + '_' + cellIndex + '_label'"
                              >
                            {{cellItem.title}} [switch_{{index}}_{{cellIndex}}]
                          </span>

                            </label>
                          </div>

                          <!--
                                                <display-debug>
                                                  <template #debugView>
                                                    cellItem-switch {{cellItem}}
                                                  </template>
                                                </display-debug>
                                                -->
                        </td>


                      </template>

                      <template
                          v-else-if="cellItem.type == 'button'"
                      >
                        <td
                            :class="'text-end '+ getCellClass(cellIndex, item.header)"
                        >
                          <template
                              v-for="(button, index) in cellItem.buttons"
                          >
                            <router-link
                                v-if="button.type == 'router'"
                                :to="button.path"
                                :class="button.class + ' btn-sm ms-2 mb-1'"
                            >
                              <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                              <span v-if="button.title">{{button.title}}</span>
                            </router-link>

                            <button
                                v-else-if="button.type == 'action'"
                                @click.prevent="itemAction(button, 'row_' + listIndex )"
                                :class="button.class + ' btn-sm ms-2 mb-1'"
                            >
                              <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                              <span v-if="button.title">{{button.title}}</span>
                            </button>
                          </template>
                        </td>
                      </template>

                      <template
                          v-else-if="cellItem.type == 'table'"
                      >
                        <td
                            :class="getCellClass(cellIndex, item.header)"
                        >
                          <template
                              v-if="cellItem.value.list && Object.keys(cellItem.value.list).length > 0"
                          >

                            <table
                                :class="cellItem.class"
                            >
                              <tr
                                  v-for="(rowItem, rowIndex) in cellItem.value.list"
                                  :class="rowItem.class"
                              >
                                <td
                                    v-for="(colItem, colIndex) in rowItem.content"
                                    :class="colItem.class"
                                >
                                  <template
                                      v-if="colItem.type == 'text'"
                                  >
                                    <p v-html="colItem.value"></p>
                                  </template>

                                  <template
                                      v-else-if="colItem.type == 'button'"
                                  >
                                    <template
                                        v-for="(button, index) in colItem.buttons"
                                    >
                                      <router-link
                                          v-if="button.type == 'router'"
                                          :to="button.path"
                                          :class="button.class + ' btn-sm ms-2 mb-1'"
                                      >
                                        <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                                        <span v-if="button.title">{{button.title}}</span>
                                      </router-link>

                                      <button
                                          v-else-if="button.type == 'action'"
                                          @click.prevent="itemAction(button, 'row_' + listIndex )"
                                          :class="button.class + ' btn-sm ms-2 mb-1'"
                                      >
                                        <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                                        <span v-if="button.title">{{button.title}}</span>
                                      </button>
                                    </template>
                                  </template>
                                  <template
                                      v-else
                                  >
                                  <!---->
                                  <display-debug>
                                    <template #debugView>
                                      table colItem {{colItem}}
                                    </template>
                                  </display-debug>

                                  </template>
                                </td>
                              </tr>
                            </table>
                          </template>
                        </td>
                      </template>

                      <template
                          v-else
                      >
                        <td
                            :class=" getCellClass(cellIndex, item.header)"
                        >
                          <span v-html="cellItem.value"></span>
                        </td>
                      </template>
                    </template>

                  </tr>

                </template>
              </draggable>


              <tbody>
                <tr
                  v-if="1 == 0"
                  v-for="(listItem, listIndex) in item.list"
                  :class="listItem.class?listItem.class:'no-class'"
                  :ref="'row_' + listIndex "
                >
                  <template
                      v-for="(cellItem, cellIndex) in listItem.content"
                  >
                    <template
                      v-if="cellItem.type == 'checkbox'"
                    >
                      <td
                        :class="getCellClass(cellIndex, item.header) "
                      >
                        <input
                            :ref="'checkbox_' + cellIndex"
                            type="checkbox"
                            v-model="formData"
                            :value="cellItem.value"
                            class="form-check-input ms-2"
                        >
                      </td>
                    </template>

                    <template
                        v-else-if="cellItem.type == 'move'"
                    >
                      <td>
                        <i class="bi bi-arrows-move fs-5 text-secondary "/>
                      </td>
                    </template>
                    <template
                        v-else-if="cellItem.type == 'image'"
                    >
                      <td
                          :class="getCellClass(cellIndex, item.header) "
                      >
                        <image-component
                            v-if="cellItem.image_id"
                            :image-id="cellItem.image_id"
                            :is_preview_only="true"
                        />
                      </td>
                    </template>

                    <template
                        v-else-if="cellItem.type == 'multiline'"
                    >
                      <td
                          :class="getCellClass(cellIndex, item.header) "
                      >
                        <template
                            v-if="cellItem.value"
                            v-for="(line, index) in cellItem.value"
                        >
                          <p
                              v-html="line"
                              class="text-muted fs-6"
                          />
                        </template>
                      </td>
                    </template>

                    <template
                        v-else-if="cellItem.type == 'progress_bar'"
                    >
                      <td
                          :class="getCellClass(cellIndex, item.header) "
                      >
                        <div class="progress">
                          <div
                              class="progress-bar"
                              :style="'width:' + cellItem.procents + '%'"
                          >
                            <span
                                v-if="cellItem.procents > 25"
                            >
                              {{cellItem.title}}
                            </span>
                          </div>
                          <span
                              v-if="cellItem.procents < 25"
                              class="ps-1 text-primary"
                          >
                            {{cellItem.title}}
                          </span>
                        </div>
                      </td>
                    </template>

                    <template
                        v-else-if="cellItem.type == 'ico'"
                    >
                      <td
                          :class="getCellClass(cellIndex, item.header) "
                      >
                        <i
                          v-if="cellItem.value"
                          :class="cellItem.value"
                        />
                      </td>
                    </template>

                    <template
                        v-else-if="cellItem.type == 'bool'"
                    >
                      <template
                        v-if="cellItem.value === true"
                      >
                        <td
                            :class="'text-success '+ getCellClass(cellIndex, item.header) "
                            xclass="text-success"

                        >
                          <i class="bi bi-check"></i>
                          <span>Ano</span>
                        </td>
                      </template>
                      <template
                        v-else-if="cellItem.value === false"
                      >
                        <td
                            :class="'text-danger '+ getCellClass(cellIndex, item.header)"
                        >
                          <i class="bi bi-x"></i>
                          <span>Ne</span>
                        </td>
                      </template>
                      <template
                        v-else
                      >
                        <td></td>

                      </template>
                    </template>

                    <template
                        v-else-if="cellItem.type == 'switch'"
                    >
                      <td
                          :class="getCellClass(cellIndex, item.header)"
                      >
                        <div class="form-check form-switch">
                          <label class="--form-check-label">
                            <input
                                :ref="'switch_' + listIndex + '_' + cellIndex"
                                @change="switchAction($event, 'switch_' + listIndex + '_' + cellIndex, cellItem, listItem)"
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                :checked="cellItem.value"
                            />
                            <span
                                :ref="'switch_' + listIndex + '_' + cellIndex + '_label'"
                            >
                            {{cellItem.title}} [switch_{{listIndex}}_{{cellIndex}}]
                          </span>

                          </label>
                        </div>

                        <!--
                                              <display-debug>
                                                <template #debugView>
                                                  cellItem-switch {{cellItem}}
                                                </template>
                                              </display-debug>
                                              -->
                      </td>


                    </template>

                    <template
                      v-else-if="cellItem.type == 'button'"
                    >
                      <td
                          :class="'text-end '+ getCellClass(cellIndex, item.header)"
                      >
                       <template
                           v-for="(button, index) in cellItem.buttons"
                       >
                         <router-link
                             v-if="button.type == 'router'"
                             :to="button.path"
                             :class="button.class + ' btn-sm ms-2 mb-1'"
                         >
                           <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                           <span v-if="button.title">{{button.title}}</span>
                         </router-link>

                         <button
                             v-else-if="button.type == 'action'"
                             @click.prevent="itemAction(button, 'row_' + listIndex )"
                             :class="button.class + ' btn-sm ms-2 mb-1'"
                         >
                           <i v-if="button.icon" :class="button.icon + '  me-1'"></i>
                           <span v-if="button.title">{{button.title}}</span>
                         </button>
                       </template>
                      </td>
                    </template>

                    <template
                      v-else
                    >
                      <td
                        :class=" getCellClass(cellIndex, item.header)"
                        v-html="cellItem.value"
                      >
                      </td>
                    </template>
                  </template>
                </tr>


              </tbody>

              <tfoot
                  v-if="item.footer && Object.keys(item.footer).length > 0"
              >
                <tr>
                  <td
                    v-for="(footerItem, index) in item.footer"
                  >
                    <div
                      v-if="
                        footerItem.select_all
                        && footerItem.select_all.status
                      "
                    >
                      <span
                        @click.prevent="selectAll(footerItem.select_all)"
                        class="text-secondary"
                      >
                        <i
                            :class="'bi bi-check-all me-2'"
                        ></i>
                        {{ footerItem.select_all.title }}
                      </span>
                    </div>

                    <p
                      v-if="footerItem.value"
                      class="text-muted"
                    >
                      {{ footerItem.value }}
                    </p>
                  </td>
                </tr>
              </tfoot>
            </table>

            <template
                v-if="item.paging && Object.keys(item.paging).length > 0"
            >
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <!--
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  -->


                  <li
                      v-for="(page, index) in item.paging.list"
                      :class="'page-item' + (page.is_active?' active':'')">
                    <a
                        @click.prevent="pagingAction(page)"
                        class="page-link"
                        :href="'#' + page.path"
                    >
                      <!--
                      {{page.title}}/
                      -->
                      {{page.page}}
                    </a>
                  </li>

                  <!--
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                  -->
                </ul>
              </nav>


              <!--
                            <display-debug>
                              <template #debugView>
                                item-paging {{item.paging}}
                              </template>
                            </display-debug>
                            -->
            </template>

            <template
                v-if="item.button && Object.keys(item.button).length > 0"
            >
             <div
              class="d-flex justify-content-center"
             >
               <button
                v-for="(button, index) in item.button"
                @click.prevent="listAction(
                    button
                    )"
                :class="button.class + ' ms-2 btn-lg'"
               >
                 {{button.title}}
               </button>
             </div>
            </template>


          </template>

          <template
              v-else
          >
            <template
                v-if="
                  item.option
                  && item.option.display_empty
                "
            >
            <div
              class="d-flex justify-content-center align-content-center py-3"
            >
              <div
                class="text-danger fs-5 "
              >
                <i
                    v-if="item.option.display_icon"
                    :class="item.option.display_icon + ' me-2'"
                />
                <span
                    v-if="item.option.display_title"
                >
                {{ item.option.display_title }}
              </span>

              </div>


            </div>





            </template>
          </template>

          <!--
          <display-debug>
            <template #debugView>
              item-list {{item}}
            </template>
          </display-debug>
          -->
        </template>

        <template
            v-else-if="item.type == 'graph_cake'"
        >
          <div
            class=""
          >
            <Pie
                :options="formatPieChartData(item.data).chartOptions"
                :data="formatPieChartData(item.data).chartData"
            />
          </div>
        </template>

        <template
            v-else-if="item.type == 'graph_line'"
        >
          <div
              style="height: 25vh;"
          >
            <Line
                :options="formatPeakChartData(item.data).chartOptions"
                :data="formatPeakChartData(item.data).chartData"
            />
          </div>
        </template>

        <template
            v-else-if="item.type == 'graph_bar'"
        >
          <div
              style="height: 25vh;"
          >
            <Bar
                :options="formatPeakChartData(item.data).chartOptions"
                :data="formatPeakChartData(item.data).chartData"
            />
          </div>
        </template>

        <template
          v-else
        >
          <display-debug>
            <template #debugView>
              item  {{item}}
            </template>
          </display-debug>
        </template>
      </template>

    </template>
  </div>

<!--

  <display-debug>
    <template #debugView>
      dataDashboard {{dataDashboard}}
    </template>
  </display-debug>

  -->

<!--
  <display-debug>
    <template #debugView>structure FULL {{structure}}</template>
  </display-debug>
  -->

<!--


  <display-debug>
    <template #debugView>data {{data}}</template>
  </display-debug>


  <display-debug>
    <template #debugView>modul {{modul}}</template>
  </display-debug>
  -->
</template>

<script>
import { gsap, Back, Power1 } from "gsap"
import axios from "axios";
import InfiniteScrollList from '@/components/content/InfiniteScrollList'
import DashoboardListWrap from '@/components/general/dashboard/DashoboardListWrap'
import { Pagination, Keyboard, Autoplay } from 'swiper/modules'; // Navigation, , Scrollbar
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Pie, Line, Bar } from 'vue-chartjs'
import Masonry from 'masonry-layout';
import draggable from "vuedraggable";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    BarElement,

)

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  BarElement
} from 'chart.js'
import chroma from 'chroma-js';
import ImageComponent from "@/components/general/Image.vue";
import {type} from "@vueuse/core/index";

export default {
  name: "DashboardItem",
  components: {
    draggable,
    ImageComponent,
    chroma,
    gsap,
    Back,
    Power1,
    Pie,
    Line,
    Bar
  },
  props: {
    "dashboard": {
      required: false,
      type: Object,
    },
  },
  emits:[
    //'update:reloadSignal'
  ],
  data() {
    return {
      loading: {
        status: false,
      },
      dataDashboard: null,
      formData: [],
      msnry: null
    }
  },
  setup() {
    return {
      modules: [Keyboard, Pagination, Autoplay],
    };
  },
  methods: {
    getCellClass(index, header) {
      if(
          header
          &&  typeof header[index] != 'undefined'
          && typeof header[index].format != 'undefined'
          && typeof header[index].format.class != 'undefined'
          && header[index].format.class
      ) {
        return header[index].format.class;
      }
    },

    selectAll(item) {
      const refIdent = 'checkbox_' + item.ident;
      if(this.$refs[refIdent]){
        this.$refs[refIdent].forEach(el => {
          el.checked = !el.checked;
          if(el.checked) {
            this.formData.push(el.value);
          } else {
            this.formData = this.formData.filter(i => i != el.value);
          }
        });
      }
    },

    switchAction(event, ref, item, data) {
       const formData = new FormData
       formData.append('checked', event.target.checked);
       if(data) {
         formData.append('data', JSON.stringify(data));
        }
       if(item.params) {
         if (item.params) {
           for (const i in item.params) {
             formData.append(i, item.params[i])
           }
         }
       }else if(item.switch.params){
         if (item.switch.params) {
           for (const i in item.switch.params) {
             formData.append(i, item.switch.params[i])
           }
         }
       }

       this.loading.status = true;
       axios({
         url: item.switch.action,
         method: item.switch.method,
         data: formData,
         withCredentials: true,
         headers: this.getRequestHeader(),
       }).then((res) => {
         if(res.data.response.callback) {
           if(typeof res.data.response.callback.checked != 'undefined') {
             this.$refs[ref][0].checked =  !!res.data.response.callback.checked ;
           }
           if(typeof res.data.response.callback.title != 'undefined') {
             this.$refs[ref + '_label'][0].textContent = res.data.response.callback.title ;
           }
         }
       })
       .catch((err) => {
         console.error("dev switchAction catch", err);
       })
       .finally((data) =>{
         this.loading.status = false;
       })
    },
    coreAction(item, ref = null) {
      const formData = new FormData
      formData.append('form_inputs', JSON.stringify(this.formData));
      if(item.params) {
        for (const i in item.params) {
          formData.append(i, item.params[i])
        }
      }

      this.loading.status = true;
      axios({
        url: item.action,
        method: item.method,
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.response.callback) {
          for(const i in res.data.response.callback) {
            this.dataDashboard[i] = res.data.response.callback[i];
          }
        }

        if(ref) {
          console.log("dev coreAction ref", res.data.response);
          //dom acation
          if(res.data.response.is_modify_ref) {
            ref.outerHTML = res.data.response.modify_ref_content;
          }else if(res.data.response.is_delete_ref) {
            ref.remove(); // Nativní JavaScript metoda pro odstranění z DOMu
          }
        }
      })
      .catch((err) => {
        console.log("dev coreAction catch", err);
      })
      .finally((data) =>{
        this.loading.status = false;
      })
    },

    reloadAction(item) {
      console.log("dev reloadAction", item);
      this.coreAction(item)
    },

    listDragnDropAction(listData, actions) {
      if(
          actions
          && actions.dragndrop
      ) {
        const formData = new FormData
        formData.append('list_data', JSON.stringify(listData));

        this.loading.status = true;
        axios({
          url: actions.dragndrop.action,
          method: actions.dragndrop.method,
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        })
        .then((res) => {
          console.log("dev listDragnDropAction RES", res);
        })
        .catch((err) => {
          console.log("dev coreAction catch", err);
        })
        .finally((data) =>{
          this.loading.status = false;
        })
      }
    },

    listAction(item) {
      console.log("dev listAction", item);
      this.coreAction(item)

    },
    itemAction(item, ref = null) {
      console.log('dev.itemAction', ref, item);
      this.coreAction(item, this.$refs[ref][0])
    },
    buttonAction(item) {
      console.log('dev.buttonAction', item);
      this.coreAction(item)
    },
    pagingAction(item) {
      console.log('dev.pagingAction', item);
    },
    createBsColor(hue, refColor = null) {
      if(
          refColor == null
      ) {
        refColor = '#0d6efd'
      }
// Získáme hodnoty L (jas) a C (sytost) z originálu
      const refL = chroma(refColor).get('lch.l');
      const refC = chroma(refColor).get('lch.c');

      return chroma.lch(refL, refC, hue).hex()
    },

    formatPeakChartData(data) {
      const resData = {
        chartData: {
          labels: data.labels,
          datasets: []
        },
        chartOptions: {
          responsive: true,
          plugins: {
            legend: {
              display: (data.dataset.length > 1)? true: false
            }
          },
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true // Osa Y začne od nuly
            }
          }
        }
      };


      if(data.dataset) {
        let baseColor = null;
        if(data.baseColor) {
          baseColor = data.baseColor
        }

        let index = 1;
        const datasetCount = Object.keys(data.dataset).length;
        for (const i in data.dataset) {
          const currentHue = (index / datasetCount) * 360;
          //const randomColor = this.createBsColor(currentHue/4, 'rgb(128,255,0)');
          const randomColor = this.createBsColor(currentHue/4, baseColor);

          const datasetItem = {
            label: data.dataset[i].title,
            //backgroundColor: data.dataset[i].color? data.dataset[i].color: randomColor,
            //borderColor: data.dataset[i].color? data.dataset[i].color: randomColor,
            backgroundColor:  randomColor,
            borderColor: randomColor,

            responsive: true,
            borderWidth: 3,           // Tloušťka čáry (např. 5px)
            pointRadius: 3,           // Velikost bodu v klidu
            pointHoverRadius: 9,      // Velikost bodu při najetí myší

            borderRadius: {
              topLeft: 0,
              topRight: 20,
              bottomLeft: 0,
              bottomRight: 0
            },

            data: data.dataset[i].values,
            tension: 0,
            spanGaps: true
          }
          resData.chartData.datasets.push(datasetItem)
          index++;
        }
      }

      return resData;

    },
    formatPieChartData(data) {
      const resData = {
        chartData: {
          labels: [],
          datasets: [
            {
              label: 'Label #1',

              //backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
              backgroundColor: [],
              data: []
            }
          ]
        },
        chartOptions: {
          responsive: false,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'left'
            },
            title: {
              display: false,
              text: data.title
            }
          }
        }
      };

      if(data.dataset) {
        //console.log('dev.formatPieChartData dataset', Object.keys(data.dataset).length , baseColor, this.createContrastColor(baseColor));
        let baseColor = null;
        if(data.baseColor) {
          baseColor = data.baseColor
        }

        let index = 1;
        const datasetCount = Object.keys(data.dataset).length;

        for(const i in data.dataset) {
          resData.chartData.labels.push( data.dataset[i].title);
          resData.chartData.datasets[0].data.push(data.dataset[i].value);

          const currentHue = (index / datasetCount) * 360;
          const currentColor = this.createBsColor(currentHue/1, baseColor);

          resData.chartData.datasets[0].backgroundColor.push(
              currentColor
          );
          index++;
        }
      }
      return resData;

    },
    createContrastColor(baseColor) {
// Zjistíme jas barvy (0 = černá, 1 = bílá)
      const luminance = chroma(baseColor).luminance();

      // Parametry pro náhodnou barvu:
      const randomHue = Math.random() * 360;
      const saturation = 0.7; // Dostatečná sytost, aby barva nebyla šedivá

      // Pokud je základní barva tmavá ( < 0.5), zvolíme vysoký jas (0.85)
      // Pokud je základní barva světlá, zvolíme nízký jas (0.15)
      const lightness = luminance < 0.5 ? 0.85 : 0.15;

      return chroma.hsl(randomHue, saturation, lightness).hex();
    }
  },
  mounted() {
    this.dataDashboard = this.dashboard;

    // Inicializace po vykreslení


    this.$nextTick(() => {
      //console.log('dev mounted $nextTick')

      this.msnry = new Masonry('.masonry-container', {
        itemSelector: '.masonry-item',
        columnWidth: '.masonry-item',
        percentPosition: true,
        gutter: 0 // mezera mezi bloky
      });

      //console.log('dev mounted this.msnry', this.msnry)
    });






  }
};
</script>
<style scoped type="text/scss">
  .dashboard-cell-id,
  .dashboard-cell-ico,
  .dashboard-cell-bool,
  .dashboard-cell-checkbox {
    width: 1rem;
    text-align: center;
  }

  .move-row {
    cursor: move;
  }
  .move-ghost {
      opacity: 0.5;
      //background: black;
  }
</style>